import { useRecoilValue } from "recoil";
import { PassIcon, ProfileIcon, UsersIcon } from "../../../../assets/icons";
import { userAtom } from "../../../../services/atoms/auth.atoms";

const SideBarConfiguration = ({ setViewSelected, viewSelected }) => {
  const user = useRecoilValue(userAtom);
  return (
    <div className="gm-sidebar-config-container">
      <ul>
        <li>Mi cuenta</li>
        <button
          className={
            viewSelected === "profile" ? "gm-sidebar-config-view-selected" : ""
          }
          name="profile"
          onClick={(event) => {
            setViewSelected(event.target.name);
          }}
        >
          <ProfileIcon /> Perfil
        </button>
        <button
          className={
            viewSelected === "password" ? "gm-sidebar-config-view-selected" : ""
          }
          name="password"
          onClick={(event) => {
            setViewSelected(event.target.name);
          }}
        >
          <PassIcon /> Contraseña
        </button>
      </ul>

      {user.data.isSuperAdmin && (
        <ul>
          <li>Sistema</li>
          <button
            className={
              viewSelected === "users" ? "gm-sidebar-config-view-selected" : ""
            }
            name="users"
            onClick={(event) => {
              setViewSelected(event.target.name);
            }}
          >
            <UsersIcon /> Usuarios
          </button>
        </ul>
      )}
    </div>
  );
};

export default SideBarConfiguration;
